import { useEffect, useRef, useState } from "react";
import { useSession } from "../session/useSession";
import { MarkdownView } from "../components/MarkdownView";
import { ui, disabledStyle } from "../components/uiStyles";

/**
 * Paso 4: Comparación de las opciones marcadas en Step 3.
 *
 * Auto-dispara la llamada al montar (no requiere otro click del usuario —
 * ya seleccionó las opciones en step 3). Cuando termina, muestra markdown
 * + selector para elegir una opción → paso 5.
 */
export function Step4Compare() {
  const {
    formData,
    responses,
    loading,
    error,
    runCompare,
    updateFormField,
    resetStep,
    goToStep,
  } = useSession();

  const r4 = responses[4];
  const markdown = r4?.markdown;
  const selectedNames = formData.selectedOptionNames || "";

  // Evita dobles auto-disparos (Strict Mode + cambios de deps)
  const triggered = useRef(false);

  useEffect(() => {
    if (!markdown && selectedNames && !loading && !triggered.current) {
      triggered.current = true;
      runCompare(selectedNames);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNames]);

  // Para el dropdown "ya me decidí"
  const [chosen, setChosen] = useState("");
  const names = selectedNames.split(",").map((s) => s.trim()).filter(Boolean);

  const handleChoose = () => {
    if (!chosen) return;
    updateFormField("chosenProduct", chosen);
    // Limpiar responses[5] para que Step5 se re-monte con el nuevo chosen.
    // runWhereToBuy detectará si hay cache para ese producto y lo restaurará
    // instantáneamente, o llamará al backend si es un producto nuevo.
    resetStep(5);
    goToStep(5);
  };

  return (
    <div style={ui.card}>
      <h2 style={ui.h2}>Comparación de opciones</h2>

      <div style={ui.infoBadge}>
        Comparando: <strong>{selectedNames}</strong>
      </div>

      {loading && (
        <p style={{ fontSize: "13px", color: "#888" }}>Generando comparación...</p>
      )}

      {error && <div style={ui.errorBox}>❌ {error}</div>}

      {markdown && (
        <>
          <MarkdownView>{markdown}</MarkdownView>

          <div style={{ marginTop: "18px" }}>
            <p style={{ fontSize: "13px", fontWeight: 600, color: "#1a1a2e", marginBottom: "10px" }}>
              ¿Qué quieres hacer ahora?
            </p>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
              <button style={ui.secondaryBtn} onClick={() => goToStep(3)}>
                🔁 Cambiar productos / ajustar requisitos
              </button>
              <button
                style={ui.secondaryBtn}
                disabled={loading}
                onClick={() => runCompare(selectedNames, { force: true })}
                title="Ignora el resultado guardado y consulta al modelo de nuevo"
              >
                🔄 Recomparar
              </button>

              <select
                style={{ ...ui.input, width: "auto", padding: "8px 12px" }}
                value={chosen}
                onChange={(e) => setChosen(e.target.value)}
              >
                <option value="">Ya me decidí por...</option>
                {names.map((n, i) => (
                  <option key={i} value={n}>
                    {n}
                  </option>
                ))}
              </select>
              <button
                style={{ ...ui.primaryBtn, ...(!chosen ? disabledStyle : {}) }}
                disabled={!chosen}
                onClick={handleChoose}
              >
                Buscar opciones de comprar →
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
